"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _togaIcon = _interopRequireDefault(require("@thinkific/toga-icon"));

var _Pagination = _interopRequireDefault(require("./Pagination.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable jsx-a11y/anchor-is-valid */
var cx = _bind["default"].bind(_Pagination["default"]);

var Pagination = function Pagination(_ref) {
  var currentPage = _ref.currentPage,
      goTofirstHandler = _ref.goTofirstHandler,
      goTolastHandler = _ref.goTolastHandler,
      previousHandler = _ref.previousHandler,
      nextHandler = _ref.nextHandler,
      goToPageHandler = _ref.goToPageHandler,
      desiredNumberOfPages = _ref.desiredNumberOfPages,
      isCompactMode = _ref.isCompactMode,
      totalPages = _ref.totalPages;
  var newDesireTotalPages = desiredNumberOfPages > totalPages ? totalPages : desiredNumberOfPages;
  var paginationItems = [];
  var itemsOnEachSide = Math.floor(newDesireTotalPages / 2);
  var startNumber = Math.max(currentPage - itemsOnEachSide, 1); // Edge case last page of the pagination

  if (currentPage >= totalPages) {
    startNumber = totalPages - newDesireTotalPages + 1;
  } // Edge case if the pagination item can fit all items


  if (currentPage + itemsOnEachSide > totalPages) {
    startNumber = totalPages - newDesireTotalPages + 1;
  }

  var _loop = function _loop(i) {
    var displayNumber = i;
    paginationItems.push( /*#__PURE__*/_react["default"].createElement("li", {
      className: cx('pagination__index', "pagination__item--".concat(displayNumber), {
        active: currentPage === displayNumber
      }),
      key: displayNumber
    }, /*#__PURE__*/_react["default"].createElement("a", {
      role: "button",
      tabIndex: displayNumber,
      onClick: function onClick() {
        return goToPageHandler(displayNumber);
      },
      onKeyPress: function onKeyPress() {
        return goToPageHandler(displayNumber);
      }
    }, displayNumber)));
  };

  for (var i = startNumber; i < startNumber + newDesireTotalPages; i += 1) {
    _loop(i);
  }

  var isBackButtonInactive = currentPage === 1;
  var isNextButtonInactive = currentPage === totalPages;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: cx('pagination', {
      'pagination--compact-mode': isCompactMode
    })
  }, /*#__PURE__*/_react["default"].createElement("ul", null, !isCompactMode && /*#__PURE__*/_react["default"].createElement("li", {
    className: cx('toFirstBtn', {
      inactive: isBackButtonInactive
    })
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "aria-label": "Go to the first page",
    role: "button",
    tabIndex: 0,
    onClick: !isBackButtonInactive ? goTofirstHandler : undefined,
    onKeyPress: !isBackButtonInactive ? goToPageHandler : undefined
  }, /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
    name: "bullet",
    "aria-hidden": true
  }))), /*#__PURE__*/_react["default"].createElement("li", {
    className: cx('toPreviousBtn', {
      inactive: isBackButtonInactive
    })
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "aria-label": "Go to the previous page",
    role: "button",
    tabIndex: 0,
    onClick: !isBackButtonInactive ? previousHandler : undefined,
    onKeyPress: !isBackButtonInactive ? goToPageHandler : undefined
  }, /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
    name: "arrow-left",
    "aria-hidden": true
  }))), !isCompactMode && paginationItems, isCompactMode && /*#__PURE__*/_react["default"].createElement("span", {
    className: cx('compact-mode--spacer')
  }), /*#__PURE__*/_react["default"].createElement("li", {
    className: cx('toNextBtn', {
      inactive: isNextButtonInactive
    })
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "aria-label": "Go to the next page",
    role: "button",
    tabIndex: newDesireTotalPages + 1,
    onClick: !isNextButtonInactive ? nextHandler : undefined,
    onKeyPress: !isNextButtonInactive ? goToPageHandler : undefined
  }, /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
    name: "arrow-right",
    "aria-hidden": true
  }))), !isCompactMode && /*#__PURE__*/_react["default"].createElement("li", {
    className: cx('toLastBtn', {
      inactive: isNextButtonInactive
    })
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "aria-label": "Go to the last page",
    role: "button",
    tabIndex: newDesireTotalPages + 1,
    onClick: !isNextButtonInactive ? goTolastHandler : undefined,
    onKeyPress: !isNextButtonInactive ? goToPageHandler : undefined
  }, /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
    name: "bullet",
    "aria-hidden": true
  })))));
};

Pagination.propTypes = {
  currentPage: _propTypes["default"].number.isRequired,
  desiredNumberOfPages: _propTypes["default"].number,
  goTofirstHandler: _propTypes["default"].func,
  goTolastHandler: _propTypes["default"].func,
  goToPageHandler: _propTypes["default"].func,
  isCompactMode: _propTypes["default"].bool,
  nextHandler: _propTypes["default"].func,
  previousHandler: _propTypes["default"].func,
  totalPages: _propTypes["default"].number.isRequired
};
Pagination.defaultProps = {
  goTofirstHandler:
  /* istanbul ignore next */
  function goTofirstHandler() {},
  goTolastHandler:
  /* istanbul ignore next */
  function goTolastHandler() {},
  previousHandler:
  /* istanbul ignore next */
  function previousHandler() {},
  nextHandler:
  /* istanbul ignore next */
  function nextHandler() {},
  goToPageHandler:
  /* istanbul ignore next */
  function goToPageHandler() {},
  desiredNumberOfPages: 5,
  isCompactMode: false
};
var _default = Pagination;
exports["default"] = _default;